export default {
    notifications: state => state.notifications,
    notificationsLoading: state => state.notificationsLoading,
    lastNotifications: state => state.lastNotifications,
    numActive: state => state.numActive,
    numberOfNewNotifications: state => state.numberOfNewNotifications
};
